// =============================
// CART DRAWER (Clearflow — Final Stable Version)
// =============================

/**
 * Get the currency currently selected in the Bucks CC widget.
 * Tries window.bucksCC API first, then DOM fallback. Returns null if unknown.
 */
function getBucksSelectedCurrency() {
  let source = 'none';
  const storedCurrency = localStorage.getItem('doubly_currency') || localStorage.getItem('currency');
  if (storedCurrency) {
    const code = storedCurrency.replace(/['"]/g, '').trim().toUpperCase();
    if (/^[A-Z]{3}$/.test(code)) {
      source = 'storage';
      return code;
    }
  }
  if (window.bucksCC) {
    if (typeof window.bucksCC.getSelectedCurrency === 'function') {
      const code = window.bucksCC.getSelectedCurrency();
      if (code && typeof code === 'string') {
        source = 'getSelectedCurrency';
        return code.trim();
      }
    }
    if (typeof window.bucksCC.currentCurrency === 'string' && window.bucksCC.currentCurrency) {
      source = 'currentCurrency';
      return window.bucksCC.currentCurrency.trim();
    }
    if (typeof window.bucksCC.selectedCurrency === 'string' && window.bucksCC.selectedCurrency) {
      source = 'selectedCurrency';
      return window.bucksCC.selectedCurrency.trim();
    }
    // Bucks API shape from runtime: config, getConfig, localization, Currency, widget, etc.
    try {
      const cfg = typeof window.bucksCC.getConfig === 'function' ? window.bucksCC.getConfig() : window.bucksCC.config;
      if (cfg && typeof cfg === 'object') {
        const code = (cfg.userCurrency || cfg.selectedCurrency || cfg.currency || cfg.iso_code || (cfg.currency && cfg.currency.iso_code));
        if (typeof code === 'string' && code.trim()) {
          source = 'config';
          return code.trim();
        }
        if (cfg.currency && typeof cfg.currency === 'object' && typeof cfg.currency.iso_code === 'string') {
          source = 'config.currency';
          return cfg.currency.iso_code.trim();
        }
      }
    } catch (_) {}
    try {
      const loc = window.bucksCC.localization;
      if (loc && typeof loc === 'object') {
        const code = (loc.currency && (typeof loc.currency === 'string' ? loc.currency : loc.currency.iso_code))
          || loc.selectedCurrency
          || loc.iso_code;
        if (typeof code === 'string' && code.trim()) {
          source = 'localization';
          return code.trim();
        }
      }
    } catch (_) {}
  }
  const el = document.querySelector('.bucks-selected [data-currency], .buckscc-select-styled [data-currency], .buckscc-currency-box [data-currency]');
  if (el && el.getAttribute('data-currency')) {
    source = 'dom';
    return el.getAttribute('data-currency').trim();
  }
  return null;
}

function getCurrencyPrecision(currency) {
  return ['KWD', 'BHD', 'OMR'].includes((currency || '').toUpperCase()) ? 3 : 2;
}

function extractPrice(text, currency) {
  if (text === undefined || text === null) return null;
  const match = String(text).match(/-?\d[\d.,]*/);
  if (!match) return null;

  let value = match[0];
  const lastComma = value.lastIndexOf(',');
  const lastDot = value.lastIndexOf('.');
  const precision = getCurrencyPrecision(currency);

  if (lastComma !== -1 && lastDot !== -1) {
    const decimalSeparator = lastComma > lastDot ? ',' : '.';
    const thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
    value = value.split(thousandsSeparator).join('');
    value = value.replace(decimalSeparator, '.');
  } else if (lastComma !== -1) {
    const decimalDigits = value.length - lastComma - 1;
    value = decimalDigits > 0 && decimalDigits <= precision
      ? value.replace(',', '.')
      : value.replace(/,/g, '');
  } else if (lastDot !== -1) {
    const decimalDigits = value.length - lastDot - 1;
    if (decimalDigits < 1 || decimalDigits > precision) value = value.replace(/\./g, '');
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function getCurrencySymbol(text) {
  if (text === undefined || text === null) return null;
  let match = text.match(/^[^\d]+/);
  return match ? match[0].replace(/[.\s]/g, '').trim() : '';
}

function formatShippingAmount(amount, currency) {
  let formatted = Number(amount).toFixed(getCurrencyPrecision(currency));
  if (currency && currency.includes('QAR')) {
    formatted = formatted.replace('.', ',');
  }
  return formatted;
}

function setTextIfChanged(el, value) {
  if (el && el.textContent !== value) el.textContent = value;
}

function setHtmlIfChanged(el, value) {
  if (el && el.innerHTML !== value) el.innerHTML = value;
}

function setAttrIfChanged(el, name, value) {
  if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
}

function getActiveCurrencyCode() {
  const bucksEl = document.querySelector('.buckscc-select-styled .bucks-selected');
  if (bucksEl && bucksEl.textContent) {
    return bucksEl.textContent.trim();
  }
  const selectedCurrency = getBucksSelectedCurrency();
  if (selectedCurrency) return selectedCurrency;
  const drawer = document.querySelector('cart-drawer');
  if (drawer && drawer.getAttribute('data-store-currency')) {
    return drawer.getAttribute('data-store-currency').trim();
  }
  return 'AED';
}

function getCartSubtotalAed(goalStrip) {
  const drawer = document.querySelector('cart-drawer');
  const fromStrip = parseFloat(goalStrip?.getAttribute('data-cart-subtotal-aed'));
  if (!isNaN(fromStrip)) return fromStrip;
  const fromDrawer = parseFloat(drawer?.getAttribute('data-cart-subtotal-aed'));
  if (!isNaN(fromDrawer)) return fromDrawer;
  return null;
}

function getDisplaySubtotal(subtotalMoneyEl, aedSubtotal, activeCurrency, drawer) {
  const storeCurrency = drawer?.getAttribute('data-store-currency') || 'AED';
  let displaySubtotal = extractPrice(subtotalMoneyEl?.textContent, activeCurrency);
  const isConverted = subtotalMoneyEl?.classList.contains('buckscc-converted');
  const cachedRate = parseFloat(drawer?.getAttribute('data-last-conversion-rate'));

  if (activeCurrency === storeCurrency) {
    if ((displaySubtotal === null || isNaN(displaySubtotal)) && aedSubtotal) {
      displaySubtotal = aedSubtotal;
    }
    return { displaySubtotal, conversionRate: 1 };
  }

  if (
    displaySubtotal !== null &&
    !isNaN(displaySubtotal) &&
    isConverted &&
    aedSubtotal &&
    aedSubtotal > 0
  ) {
    const conversionRate = displaySubtotal / aedSubtotal;
    if (drawer) drawer.setAttribute('data-last-conversion-rate', String(conversionRate));
    return { displaySubtotal, conversionRate };
  }

  const conversionRate = cachedRate && !isNaN(cachedRate) ? cachedRate : 1;
  if (aedSubtotal && aedSubtotal > 0) {
    displaySubtotal = aedSubtotal * conversionRate;
  }

  return { displaySubtotal, conversionRate };
}

function getConfiguredShippingAmounts(goalStrip, currency, conversionRate) {
  const currencyPrefixes = {
    KWD: 'k',
    BHD: 'b',
    OMR: 'o',
    QAR: 'q',
    SAR: 's',
  };
  const prefix = currencyPrefixes[currency] || '';
  const rate = prefix ? 1 : conversionRate;
  const configuredShipping = parseFloat(
    goalStrip.getAttribute(prefix ? prefix + 'threshold-tier2' : 'data-gcc-shipping-aed')
  );
  const configuredThreshold = parseFloat(
    goalStrip.getAttribute(prefix ? prefix + 'data-tier2' : 'data-free-shipping-aed')
  );

  return {
    shipping: Number.isFinite(configuredShipping) ? configuredShipping : 49 * rate,
    freeThreshold: Number.isFinite(configuredThreshold) ? configuredThreshold : 399 * rate,
  };
}

let progressUpdateFrame = null;
let progressUpdateTimeout = null;

function scheduleCartProgressUpdate() {
  if (progressUpdateTimeout) clearTimeout(progressUpdateTimeout);
  if (progressUpdateFrame) cancelAnimationFrame(progressUpdateFrame);

  progressUpdateTimeout = setTimeout(() => {
    progressUpdateFrame = requestAnimationFrame(() => {
      waitForShippingInputs(0);
    });
  }, 0);
}

function waitForShippingInputs(attempt) {
  const drawer = document.querySelector('cart-drawer');
  const subtotalMoneyEl = document.querySelector('.totals__subtotal-value .money');
  const goalStrip = document.querySelector('.goal-strip');

  if (!subtotalMoneyEl || !goalStrip) {
    return;
  }

  const activeCurrency = getActiveCurrencyCode();
  const storeCurrency = drawer?.getAttribute('data-store-currency') || 'AED';
  const needsConversion = activeCurrency !== storeCurrency;
  const isConverted = subtotalMoneyEl.classList.contains('buckscc-converted');
  const hasPrice = extractPrice(subtotalMoneyEl.textContent, activeCurrency) !== null;
  const aedSubtotal = getCartSubtotalAed(goalStrip);

  if (needsConversion && !isConverted && attempt < 24) {
    progressUpdateFrame = requestAnimationFrame(() => waitForShippingInputs(attempt + 1));
    return;
  }

  if (!hasPrice && aedSubtotal === null && attempt < 24) {
    progressUpdateFrame = requestAnimationFrame(() => waitForShippingInputs(attempt + 1));
    return;
  }

  updateCartProgress();
}

function updateCartProgress() {
  const goalStrip = document.querySelector('.goal-strip');
  const cartDrawerElement = document.querySelector('.drawer__inner');
  const subtotalMoneyEl = document.querySelector('.totals__subtotal-value .money');
  const progMarks = document.querySelector('.prog-marks');
  const progTrack = document.querySelector('.prog-track');
  const goalMain = document.querySelector('.goal-main');
  const goalSub = document.querySelector('.goal-sub');
  const goalUnlocked = document.querySelector('.goal-main__unlocked');
  const goalIcon = document.querySelector('.goal-icon');
  const shippingValueEl = document.querySelector('.totals__shiping-value');
  const totalValueEl = document.querySelector('.totals__subtotals-value');
  const progressText = document.querySelector('.goal-main .amt');
  const shippingAmt = document.querySelector('.goal-main .smt');
  const progressBar = document.querySelector('.prog-fill');
  const markSpans = document.querySelectorAll('.prog-marks span');
  const drawer = document.querySelector('cart-drawer');

  if (!goalStrip || !subtotalMoneyEl || !shippingValueEl || !totalValueEl) return;

  const activeCurrency = getActiveCurrencyCode();
  const countryCode = (drawer?.getAttribute('data-country-code') || '').toUpperCase();
  const aedSubtotal = getCartSubtotalAed(goalStrip);
  const { displaySubtotal, conversionRate } = getDisplaySubtotal(
    subtotalMoneyEl,
    aedSubtotal,
    activeCurrency,
    drawer
  );

  if (displaySubtotal === null || isNaN(displaySubtotal)) return;

  if (countryCode === 'AE' || activeCurrency === 'AED') {
    if (progMarks) progMarks.classList.add('hidden');
    if (progTrack) progTrack.classList.add('hidden');
    if (goalMain) goalMain.classList.add('hidden');
    setAttrIfChanged(goalStrip, 'data-ship', 'state');
    if (goalIcon) setTextIfChanged(goalIcon, '🇦🇪');
    if (goalSub) {
      goalSub.classList.remove('hidden');
      setTextIfChanged(goalSub, 'All UAE orders ship free — no minimum');
    }
    if (goalUnlocked) {
      goalUnlocked.classList.remove('hidden');
      setTextIfChanged(goalUnlocked, 'Free Shipping on your order');
    }
    setTextIfChanged(shippingValueEl, 'Free');
    setTextIfChanged(
      totalValueEl,
      activeCurrency === 'AED'
        ? 'Dhs. ' + formatShippingAmount(displaySubtotal, activeCurrency) + ' AED'
        : formatShippingAmount(displaySubtotal, activeCurrency) + ' ' + activeCurrency
    );
    return;
  }

  if (progMarks) progMarks.classList.remove('hidden');
  if (progTrack) progTrack.classList.remove('hidden');
  if (!cartDrawerElement) return;

  const {
    shipping: shippingDisplay,
    freeThreshold: freeThresholdDisplay,
  } = getConfiguredShippingAmounts(goalStrip, activeCurrency, conversionRate);
  const shippingNote =
    goalStrip.getAttribute('data-shipping-note') || 'Spend more for FREE GCC shipping';

  if (markSpans.length >= 3) {
    setTextIfChanged(markSpans[0], activeCurrency + ' 0');
    setTextIfChanged(
      markSpans[1],
      activeCurrency + ' ' + formatShippingAmount(shippingDisplay, activeCurrency)
    );
    setTextIfChanged(
      markSpans[2],
      activeCurrency + ' ' + formatShippingAmount(freeThresholdDisplay, activeCurrency)
    );
  }

  const percentageAchieved = Math.min((displaySubtotal / freeThresholdDisplay) * 100, 100);
  if (progressBar) progressBar.style.width = percentageAchieved + '%';

  if (displaySubtotal < freeThresholdDisplay) {
    setAttrIfChanged(goalStrip, 'data-ship', 'state1');
    if (goalIcon) setTextIfChanged(goalIcon, '🚚');
    if (goalMain) goalMain.classList.remove('hidden');
    if (goalSub) {
      goalSub.classList.remove('hidden');
      setTextIfChanged(goalSub, shippingNote);
    }
    if (goalUnlocked) goalUnlocked.classList.add('hidden');

    if (markSpans.length >= 3) {
      markSpans[0].classList.add('active');
      markSpans[1].classList.remove('active');
      markSpans[2].classList.remove('active');
    }

    const amountRemaining = Math.max(freeThresholdDisplay - displaySubtotal, 0);
    if (progressText) {
      setTextIfChanged(
        progressText,
        activeCurrency + ' ' + formatShippingAmount(amountRemaining, activeCurrency)
      );
    }
    if (shippingAmt) {
      setTextIfChanged(
        shippingAmt,
        '(' + activeCurrency + ' ' + formatShippingAmount(shippingDisplay, activeCurrency) + ')'
      );
    }

    setTextIfChanged(
      shippingValueEl,
      formatShippingAmount(shippingDisplay, activeCurrency) + ' ' + activeCurrency
    );
    setTextIfChanged(
      totalValueEl,
      formatShippingAmount(displaySubtotal + shippingDisplay, activeCurrency) + ' ' + activeCurrency
    );
    return;
  }

  setAttrIfChanged(goalStrip, 'data-ship', 'state3');
  if (goalUnlocked) {
    goalUnlocked.classList.remove('hidden');
    setHtmlIfChanged(goalUnlocked, 'You unlocked FREE shipping!');
  }
  if (goalMain) goalMain.classList.add('hidden');
  if (goalSub) {
    goalSub.classList.remove('hidden');
    setTextIfChanged(goalSub, 'Free shipping on this order');
  }
  if (goalIcon) setTextIfChanged(goalIcon, '🏆');

  if (markSpans.length >= 3) {
    markSpans[2].classList.add('active');
    markSpans[0].classList.remove('active');
    markSpans[1].classList.remove('active');
  }

  setTextIfChanged(shippingValueEl, 'Free');
  setTextIfChanged(
    totalValueEl,
    formatShippingAmount(displaySubtotal, activeCurrency) + ' ' + activeCurrency
  );
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Close on ESC key
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // Overlay click closes
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    // Accessibility setup
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
      scheduleCartProgressUpdate();
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => this.classList.add('animate', 'active'), 10);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : this.querySelector('#CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn && focusElement)
          trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling?.id) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      const isOpen = event.currentTarget.closest('details').hasAttribute('open');
      event.currentTarget.setAttribute('aria-expanded', !isOpen);
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  // =============================
  // MAIN RENDER LOGIC (with Empty Cart Fix)
  // =============================
  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.warn('⚠️ Invalid parsedState passed to renderContents');
      return;
    }

    const storeCurrency = (this.getAttribute('data-store-currency') || '').trim() || null;
    const selectedCurrency = getBucksSelectedCurrency();
    const needsConversion = !storeCurrency || !selectedCurrency ||
      storeCurrency.toUpperCase() !== selectedCurrency.toUpperCase();
    this._bucksNeedsConversion = needsConversion;
    if (needsConversion) {
      this.setAttribute('data-bucks-pending', '');
    } else {
      this.removeAttribute('data-bucks-pending');
    }

    const cartHTML = parsedState.sections['cart-drawer'] || '';
    const isEmpty =
      cartHTML.includes('cart__empty-text') ||
      cartHTML.includes('Your cart is empty');

    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections?.[section.id];
      if (!html) return;

      const decodedHTML = this.decodeAndExtract(html, section.selector);
      if (!decodedHTML) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (sectionElement) {
        sectionElement.innerHTML = decodedHTML;
        console.log(`✅ Updated section: ${section.id}`);
        // Trigger Bucks currency converter on new content to avoid price flash
        if (section.id === 'cart-drawer' && window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
          window.bucksCC.reConvert();
          scheduleCartProgressUpdate();
        }
      } else {
        console.warn(`⚠️ Target not found for section: ${section.id}`);
      }
    });

    // Handle empty cart display logic
    this.classList.toggle('is-empty', isEmpty);

setTimeout(() => {
  const overlay = this.querySelector('#CartDrawer-Overlay');
  if (overlay) overlay.addEventListener('click', this.close.bind(this));
  this.open();

  const emptyView = this.querySelector('.drawer__inner-empty');
  const form = this.querySelector('#CartDrawer-Form');

  if (isEmpty) {
    if (emptyView) emptyView.style.display = 'block';
    if (form) form.style.display = 'none';

    // 🧩 Fix for misaligned empty state (after removing last item)
    const innerWrapper = this.querySelector('.drawer__inner');
    if (emptyView && innerWrapper && !innerWrapper.contains(emptyView)) {
      innerWrapper.innerHTML = '';
      innerWrapper.appendChild(emptyView);
      console.log('🧩 Reattached empty state inside .drawer__inner for centering');
    }

    // Ensure it’s centered
    emptyView.style.display = 'flex';
    emptyView.style.alignItems = 'center';
    emptyView.style.justifyContent = 'center';
    emptyView.style.minHeight = '100%';

    console.log('🟢 Cart is empty — showing empty message');
  } else {
    if (emptyView) emptyView.style.display = 'none';
    if (form) form.style.display = 'block';
  }

  // Trigger Bucks re-conversion for newly injected cart prices (avoids store-currency flash)
  if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
    window.bucksCC.reConvert();
  }
  scheduleCartProgressUpdate();
  // Fallback: show prices after delay if Bucks didn't convert (only when we hid them)
  const drawer = document.querySelector('cart-drawer');
  if (drawer && drawer._bucksNeedsConversion) {
    clearTimeout(drawer._bucksFallbackTimer);
    drawer._bucksFallbackTimer = setTimeout(() => {
      drawer.removeAttribute('data-bucks-pending');
      scheduleCartProgressUpdate();
    }, 800);
  }

  console.log('🟢 Cart drawer content rendered and reopened');
}, 0);

  }

  // =============================
  // SAFE DECODE + EXTRACTION
  // =============================
  decodeAndExtract(html, selector) {
    try {
      const temp = document.createElement('textarea');
      temp.innerHTML = html;
      const decoded = temp.value;

      const parser = new DOMParser();
      const doc = parser.parseFromString(decoded, 'text/html');

      const cartEl =
        doc.querySelector('#CartDrawer') ||
        doc.querySelector(selector) ||
        doc.body;

      if (!cartEl) {
        console.warn('⚠️ No matching element found for', selector);
        return '';
      }

      cartEl.querySelectorAll('script, style').forEach((el) => el.remove());

      return cartEl.innerHTML;
    } catch (err) {
      console.error('❌ decodeAndExtract failed:', err);
      return '';
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// =============================
// FORCE-OVERRIDE CART DRAWER ITEMS HANDLER (422 Fix + Empty Cart Fix)
// =============================
if (customElements.get('cart-drawer-items')) {
  customElements.delete('cart-drawer-items');
}

class CartDrawerItems extends CartItems {
  async updateQuantity(line, quantity) {
    this.enableLoading(line);

    try {
      // ✅ Always use .js endpoint
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error(`Cart update failed (${response.status})`);

      const data = await response.json();
      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof data.items_subtotal_price === 'number') {
        const aedSubtotal = String(data.items_subtotal_price / 100);
        cartDrawer.setAttribute('data-cart-subtotal-aed', aedSubtotal);
        const goalStrip = document.querySelector('.goal-strip');
        if (goalStrip) goalStrip.setAttribute('data-cart-subtotal-aed', aedSubtotal);
        updateCartProgress();
      }

      // ✅ Decode Shopify escaped HTML safely
      const parsedState = { sections: {} };
      Object.keys(data.sections || {}).forEach((key) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = data.sections[key];
        const decoded = textarea.value;

        const parser = new DOMParser();
        const doc = parser.parseFromString(decoded, 'text/html');
        const sectionEl =
          doc.querySelector('#CartDrawer') ||
          doc.querySelector('.cart-drawer') ||
          doc.body;

        sectionEl.querySelectorAll('script,style').forEach((el) => el.remove());
        parsedState.sections[key] = sectionEl.innerHTML.trim();
      });

      cartDrawer.renderContents(parsedState);
      scheduleCartProgressUpdate();
      this.disableLoading(line);
      console.log('🟢 Cart item quantity updated successfully');
    } catch (err) {
      console.error('❌ Error updating cart:', err);
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = 'There was an error while updating your cart. Please try again.';
        errors.style.display = 'block';
        setTimeout(() => (errors.style.display = 'none'), 3000);
      }
      this.disableLoading(line);
    }
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.converterTriggers');
  if (!trigger) return;
  scheduleCartProgressUpdate();
});

function initCartShippingObservers() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || drawer._shippingObserverReady) return;
  drawer._shippingObserverReady = true;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        mutation.target.classList.contains('buckscc-converted')
      ) {
        scheduleCartProgressUpdate();
        break;
      }
    }
  });

  observer.observe(drawer, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartShippingObservers);
} else {
  initCartShippingObservers();
}
